export default {
   apiKey: "AIzaSyBZ6A6Wmcd86-fZ4MeEW99XZG77v2AyOgk",
   authDomain: "gabriel11.firebaseapp.com",
   databaseURL: "https://gabriel11.firebaseio.com"/*,
   projectId: "gabriel11",
   storageBucket: "gabriel11.appspot.com",
   messagingSenderId: "72945427181",
   appId: "1:72945427181:web:f11d5e35125e912745e2e4"*/
}